import { render, staticRenderFns } from "./SoftwareSource.vue?vue&type=template&id=45d53d76&scoped=true&"
import script from "./SoftwareSource.vue?vue&type=script&lang=js&"
export * from "./SoftwareSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d53d76",
  null
  
)

export default component.exports